import { Component, OnInit,Input, Output,EventEmitter } from '@angular/core';
import { CotizadorService } from '../../../services/general/cotizador.service';
import { Cotizacion }    from '../../../obj/cotizacion';
import { ActivatedRoute, Router } from '@angular/router';

declare let $: any;

@Component({
  selector: 'app-cotizador',
  templateUrl: './cotizador.component.html',
  styleUrls: ['./cotizador.component.css'],
  providers: [CotizadorService]
})
export class CotizadorComponent implements OnInit {
  @Input()comparar = false;
  public origen;
  public destino;
  public tipo;
  public tipoList;
  public estadia;
  public model;
  public today;
  public da:Date;
  public msgError = false;

  @Input('ctx') ctx;

  constructor(public route: ActivatedRoute,private router: Router,private cs:CotizadorService) { }

  getSelects() {
    this.cs.getOrigen().then(origen => {this.origen=origen;},error => {console.log("Error !!! " + error);});
    this.cs.getDestino().then(destino => {this.destino = destino;},error => {console.log("Error !!! " + error);});
    this.cs.getTipo().then(tipo => {
      this.tipo = tipo;
      this.tipoList = tipo;
    },error => {console.log("Error !!! " + error);});
    this.cs.getEstadia().then(estadia => {this.estadia = estadia; },error => {console.log("Error !!! " + error);});
    (this.da = new Date()).setDate(this.da.getDate() );
  }
  ngOnInit() {

     this.getSelects();
     var cotizacion=  localStorage.getItem('currentCotizacion');
      if(cotizacion==null){
          this.model= new Cotizacion(48,1,11,'','','',1,'','','','','','','','','','',true);
      }
      else{
        this.model=JSON.parse(cotizacion);
      }

      if (this.model.destino) {
        setTimeout(() => {
          console.log(this.model)
          if (parseInt(this.model.destino) == 21 ) {
            this.tipo = this.tipoList.filter(a => parseInt(a.id) >= 24);
          } else {
            this.tipo = this.tipoList.filter(a => parseInt(a.id) < 24);
          }
        }, 1000);
      }

      if (this.model.pasajerosArray) {
        if (JSON.parse(this.model.pasajerosArray).length == 0) {
          this.model.contadorPasajerosModal = 1
          this.model.pasajerosArray = [{
            Edad: null,
            Gender: "",
            Posicion: 1
          }];
        } else {
          this.model.pasajerosArray = JSON.parse(this.model.pasajerosArray);
          this.model.contadorPasajerosModal = this.model.pasajerosArray.length;
        }

      } else {
        this.model.pasajerosArray = this.model.pasajerosArray ? JSON.parse(this.model.pasajerosArray) : [
          {
            Edad: null,
            Gender: "",
            Posicion: 1
          }
        ];
        this.model.contadorPasajerosModal = 1;
      }

      this.formatdate(this.da);

  }

  fechaInicioFn() {
    document.getElementById("d_input").setAttribute("min", this.model.inicio);
  }

  destinoSelect() {
    if (this.model.destino) {
      if (parseInt(this.model.destino) == 21) {
        this.model.origen = 48
        this.tipo = this.tipoList.filter(a => parseInt(a.id) >= 24);
      } else {
        this.tipo = this.tipoList.filter(a => parseInt(a.id) < 24);
      }
    }
  }


    addPasajeros(ev) {
        this.model.pasajerosArray = ev;
        for (let i = 0; i < 8; i++) {
          this.model[`e${i+1}`] = ""
        }
        for (let i = 0; i < this.model.pasajerosArray.length; i++) {
        this.model[`e${i+1}`] = this.model.pasajerosArray[i].Edad.toString();
        }
    }

    onSubmit(){
        for (const i of this.model.pasajerosArray) {
            if ((i.Edad == "" || !i.Edad) || i.Gender == -1) {
                this.msgError = true;
            }
        }

        if (!this.msgError) {
            if(this.ctx=='2x1assistcard'){

                (<any>window).ga('send', 'event', {
                    eventCategory: 'BotonCotizar',
                    eventLabel: 'Enviar',
                    eventAction: 'PromoJunio2x1',
                    eventValue: 1
                });
            }

            this.model.nombreDestino=this.destino.find( o => o.id ===  parseInt(this.model.destino)).descripcion;
            this.model.nombreOrigen=this.origen.find( o => o.id === parseInt(this.model.origen)).descripcion;
            this.model.nombreTipoViaje=this.tipo.find( o => parseInt(o.id) === parseInt(this.model.tipo)).descripcion;
            this.model.pasajerosArrayCopia = this.model.pasajerosArray;
            this.model.pasajerosArray = JSON.stringify(this.model.pasajerosArray)
            localStorage.setItem('currentCotizacion',JSON.stringify(this.model));
            let currentUrl = this.router.url; /// this will give you current url
            if(currentUrl!="/comparar")
                this.router.navigate(['/comparar']);
            else
                location.reload();
        } else {
            setTimeout(() => {
              this.msgError = false;
            }, 5000);
        }

    }

  get currentCotizacion() { return JSON.stringify(this.model); }

  formatdate(t){

    //var today = new Date();
    var dd = t.getDate();
    var mm = t.getMonth()+1; //January is 0!

    var yyyy = t.getFullYear();
    if(dd<10){
        dd='0'+(dd);
    }
    if(mm<10){
        mm='0'+mm;
    }
    //2018-01-15
    var d = yyyy+'-'+mm+'-'+dd;

    document.getElementById("c_input").setAttribute("min", d);
    if (this.model.inicio) {
      setTimeout(() => {
        document.getElementById("d_input").setAttribute("min", this.model.inicio);
      }, 1000);
    }
  }

}




// WEBPACK FOOTER //
// ./src/app/components/general/cotizador/cotizador.component.ts